import Vue from 'vue'
import ElementUI, { Message } from 'element-ui';
import axios from 'axios';
import router from '../router/index';
import { getToken, deleteToken, deleteUserName, getIsAdmin } from '@/common/js/storage';

Vue.use(ElementUI);

/* axios 配置 */
axios.defaults.timeout = 60000

/* http request 拦截器 */
axios.interceptors.request.use(
  config => {
    let url = config.url.split('?')[0]
    config.headers['Content-Type'] = 'application/json'
    let token = getToken()
    let isAdmin = getIsAdmin()
    if (url == '/zzd/api/back/login/system/admin' && !isAdmin) {
      return config
    } else {
      if (token) {
        /* 将token设置成请求头 */
        config.headers['Auth-Token'] = token
      }
      return config
    }
  },
  err => {
    return Promise.reject(err)
  }
)

/* http 响应拦截器 */
axios.interceptors.response.use(
  response => {
    switch (response.data.code) {
      case 401001:
        /*  401默认重新登录，先清除浏览器localStorage的缓存 */
        deleteToken()
        deleteUserName()
        router.replace({
          path: '/'
        })
        break
      default: return response;
    }
  },
  err => {
    if (err.response) {
      switch (err.response.status) {
        case 412:
          /* 前提条件失败（用户未注册、用户名不存在等等） */
          Message({
            message: err.response.data.message,
            type: 'error'
          })
          break
        case 415:
          /* 请求参数有误（某某字段不能为空） */
          Message({
            message: err.response.data.message,
            type: 'error'
          })
          break
        case 404:
          Message({
            message: '访问资源不存在',
            type: 'error'
          })
          break;
        case 500:
          /* 服务异常 */
          Message({
            message: err.response.data.message,
            type: 'error'
          })
          break
       default:
          break;
      }
    }
    return Promise.reject(err.response)
  }
)

export default axios;
